<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-pencil"></i> Mobile punch settings
					</template>
					<b-card-body>
						<b-form>
							<b-form-group
								label="Office"
								label-for="Office"
								:label-cols="3"
								:horizontal="true">
								<multiselect @input="getOfficeMobilePunchSettings()" v-model="selectedOffice"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</b-form-group>
							<b-form-group
								v-if="availableGeneralSettings.length > 0"
								v-for="settings in availableGeneralSettings" :key="settings.id"
								:label="settings.generalSettingsKey.keyName"
								:label-cols="3"
								:horizontal="true">
								<b-form-select
									v-if="settings.generalSettingsKey.possibleValues !== null"
									v-model="settings.generalSettingsKey.setValue"
									:options="settings.generalSettingsKey.possibleValues.values"
									class="mb-3"
									value-field="value"
									text-field="name"
									disabled-field="notEnabled"
								></b-form-select>
								<b-form-input
									v-model="settings.generalSettingsKey.setValue"
									v-if="settings.generalSettingsKey.possibleValues == null"
									placeholder="Enter Value">
								</b-form-input>
							</b-form-group>
							<div class="form-actions">
								<b-button type="button" variant="success" @click="updateGeneralSettingsOfOffice()">Save</b-button>
							</div>
						</b-form>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import Multiselect from 'vue-multiselect'
	import generalSettingsService from "@/services/generalSettingsService";
	import generalSettingsGroupIds from '@/services/generalSettingsGroupIds';
	const MOBILE_PUNCH_GENERAL_SETTINGS_GROUP_ID = 1;
	export default {
		name: "MobilePunchGeneralSettings",
		components : {
			Multiselect
		},
		data : function ()  {
			return {
				officeList: [],
				selectedOffice: null,
				mobilePunchSettingsData :[],
				availableGeneralSettings:[]
			}
		},
		methods : {
			getOfficeMobilePunchSettings(){
				this.availableGeneralSettings = [];
				if(this.selectedOffice != null){
					generalSettingsService.getGeneralSettings(
						{officeId : this.selectedOffice.id, groupId: generalSettingsGroupIds.MOBILE_PUNCH_SETTINGS_ID}
						, (data) => {
							data.forEach(d=>{
								d.generalSettingsKey.possibleValues = JSON.parse(d.generalSettingsKey.possibleValues);
							});
							this.availableGeneralSettings = data;
						});
				}
			},
			updateGeneralSettingsOfOffice(){
				let data = {};
				data.settings = this.availableGeneralSettings.map( g => {
					return{
						groupId: g.groupId,
						keyId : g.generalSettingsKey.id,
            keyCode: g.generalSettingsKey.keyCode,
						setValue: g.generalSettingsKey.setValue,
						officeGroupKeyId : g.generalSettingsKey.officeGroupKeyId,
					}
				});
				data.officeId = this.selectedOffice.id;
				data.groupId = MOBILE_PUNCH_GENERAL_SETTINGS_GROUP_ID;
				generalSettingsService.updateGeneralSettingsOfAnOffice(data, ()=> toastService.showSuccessToast("Updated Successfully"),
					()=> toastService.showErrorToast("Update failed"));
			}
		},
		mounted() {
			officeService.getOfficeList( r => {
				this.officeList = r;
			});
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
